import React, { useEffect } from 'react';
import '../styles/quartet-page.css';

const QuartetPage = () => {
  useEffect(() => {
    // Create festive snowflakes
    const createSnowflakes = () => {
      const snowflakeChars = ['❄', '❅', '❆', '✻', '✼', '❉'];
      const snowflakeCount = 25;
      const container = document.getElementById('snowflakes');

      if (!container) return;

      // Clear existing snowflakes
      container.innerHTML = '';

      for (let i = 0; i < snowflakeCount; i++) {
        const snowflake = document.createElement('div');
        snowflake.className = 'snowflake';
        snowflake.innerHTML = snowflakeChars[Math.floor(Math.random() * snowflakeChars.length)];
        snowflake.style.left = Math.random() * 100 + '%';
        snowflake.style.animationDuration = (Math.random() * 10 + 10) + 's';
        snowflake.style.animationDelay = Math.random() * 5 + 's';
        snowflake.style.fontSize = (Math.random() * 1 + 0.5) + 'em';
        snowflake.style.opacity = Math.random() * 0.6 + 0.4;
        container.appendChild(snowflake);
      }
    };

    createSnowflakes();
  }, []);

  return (
    <div className="quartet-page">
      {/* Festive snowflakes */}
      <div id="snowflakes"></div>

      {/* Header */}
      <header className="quartet-header">
        <div className="container">
          <div className="logo">
            <span className="music-note">🎵</span>
            <h1>Danang Madrigal Quartet</h1>
            <span className="music-note">🎶</span>
          </div>
          <p className="subtitle">Professional Vocal Ensemble · Danang, Vietnam</p>
        </div>
      </header>

      {/* Video Section */}
      <section className="video-section">
        <div className="container">
          <div className="video-container">
            <h2>Watch Us Perform 🎬</h2>
            <video controls preload="metadata">
              <source src="https://pxhuzw0vdaoygsep.public.blob.vercel-storage.com/ensemble/videos/Quartet%20Demo%20Reel_480p.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="video-caption">From left to right: Andrew, Robert, Anastasia, and Olga</p>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="festive-badge">🎄 Available for Holiday Events! 🎄</div>
            <h2>Elevate Your Event with Beautiful Harmonies</h2>
            <p>The Danang Madrigal Quartet brings sophistication and joy to any occasion with our versatile repertoire spanning classical masterpieces, folk traditions, jazz standards, and contemporary favorites.</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🎭</div>
              <h3>Versatile Repertoire</h3>
              <p>From classical to jazz, folk to pop - we perform it all with professional polish and authentic expression.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🌟</div>
              <h3>Professional Excellence</h3>
              <p>Part of the prestigious Danang International Choir, we bring years of training and performance experience.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🎪</div>
              <h3>Perfect for Any Event</h3>
              <p>Holiday parties, corporate events, weddings, galas - we create the perfect ambiance for your occasion.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🎁</div>
              <h3>Festive Season Ready</h3>
              <p>Our holiday repertoire will enchant your guests and create unforgettable memories this season.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact">
        <div className="container">
          <div className="contact-content">
            <h2>Book a Performance</h2>
            <p className="contact-intro">Interested in bringing the Danang Madrigal Quartet to your event? Fill out the form below and we'll get back to you promptly!</p>
            <form action="https://formsubmit.co/andrewsilber@yahoo.com" method="POST">
              {/* FormSubmit Configuration */}
              <input type="hidden" name="_subject" value="New Booking Inquiry - Danang Madrigal Quartet" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />

              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input type="text" id="name" name="name" required />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input type="email" id="email" name="email" required />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" name="phone" />
              </div>

              <div className="form-group">
                <label htmlFor="event_type">Event Type</label>
                <select id="event_type" name="event_type">
                  <option value="">Select an option</option>
                  <option value="Holiday Party">Holiday Party</option>
                  <option value="Corporate Event">Corporate Event</option>
                  <option value="Wedding">Wedding</option>
                  <option value="Gala">Gala</option>
                  <option value="Private Event">Private Event</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="event_date">Preferred Date</label>
                <input type="date" id="event_date" name="event_date" />
              </div>

              <div className="form-group">
                <label htmlFor="message">Additional Details</label>
                <textarea id="message" name="message" placeholder="Tell us about your event, venue, expected audience size, and any special requests..."></textarea>
              </div>

              <button type="submit" className="submit-btn">Send Inquiry 🎵</button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="quartet-footer">
        <div className="container">
          <p><strong>Danang Madrigal Quartet</strong></p>
          <p>Part of the Danang International Choir</p>
          <p>Danang, Vietnam</p>
          <p style={{ marginTop: '20px', fontSize: '0.9em' }}>✨ Making every event memorable with music ✨</p>
        </div>
      </footer>
    </div>
  );
};

export default QuartetPage;
